module.exports = __webpack_public_path__ + "img/slide11.e5ce6a02.png";